(function () {
  'use strict';

  angular.module('app').service('BookingModalService', BookingModalService);

  BookingModalService.$inject = ['ModalService'];

  function BookingModalService(ModalService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openBookingHistory: openBookingHistory,
      openSearchByItem: openSearchByItem,
      openBookingChangeStatus: openBookingChangeStatus,

      openSendBookingConfirmationToClient: openSendBookingConfirmationToClient,
      openSendBookingItineraryToClient: openSendBookingItineraryToClient,
      openSendBookingVouchersToClient: openSendBookingVouchersToClient,

      openSearchRelatedBookings: openSearchRelatedBookings,
    };

    return service;

    ////////////////

    // --------------------------- openBookingHistory -------------------------

    function openBookingHistory(booking) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/booking-history-modal.html',
        controller: BookingHistoryCtrl,
        controllerAs: 'vm',
        inputs: {
          booking: booking,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      BookingHistoryCtrl.$inject = ['booking', 'companyService', 'BookingService'];
    }

    function BookingHistoryCtrl(booking, companyService, BookingService) {
      var vm = this;

      vm.booking = booking;

      // Initializers
      getCompany();
      getBookingHistory();

      function getCompany() {
        vm.loadingUsers = true;
        companyService
          .getCompany(vm.booking.company_id, { skip_check_role: true })
          .subscribe((response) => {
            vm.users = response.users;

            vm.loadingUsers = false;
          });
      }

      function getBookingHistory() {
        vm.loadingBookingHistory = true;
        BookingService.getBookingHistory(vm.booking.id, { skip_check_role: true }).then(function (
          data
        ) {
          vm.bookingHistories = data;

          vm.loadingBookingHistory = false;
        });
      }
    }

    // --------------------------- openSearchByItem -------------------------

    function openSearchByItem(item, searchedProduct, successCallback, clearSearchByItem) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/search-by-item-modal.html',
        controller: SearchByItemCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          searchedProduct: searchedProduct,
          successCallback: successCallback,
          clearSearchByItem: clearSearchByItem,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      SearchByItemCtrl.$inject = [
        '$element',
        'item',
        'searchedProduct',
        'successCallback',
        'clearSearchByItem',
      ];
    }

    function SearchByItemCtrl($element, item, searchedProduct, successCallback, clearSearchByItem) {
      var vm = this;
      vm.item = item;
      vm.searchedProduct = searchedProduct;

      // Methods
      vm.onSave = onSave;
      vm.onClear = onClear;

      if (!vm.item) {
        vm.item.itemType = {};
      }

      function onSave() {
        $element.modal('hide');
        successCallback(vm.item);
      }

      function onClear() {
        clearSearchByItem();
        $element.modal('hide');
      }
    }

    // --------------------------- openBookingChangeStatus -------------------------

    function openBookingChangeStatus(booking, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/booking-change-status-modal.html',
        controller: BookingChangeStatusCtrl,
        controllerAs: 'vm',
        inputs: {
          booking: booking,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      BookingChangeStatusCtrl.$inject = ['$element', 'booking', 'successCallback'];
    }

    function BookingChangeStatusCtrl($element, booking, successCallback) {
      const vm = this;

      vm.booking = booking;

      vm.modalTitle = 'SET_STATUS_FOR_BOOKING';

      vm.showAlert = false;

      vm.canProcess = false;
      vm.canConfirm = false;
      vm.canCancel = false;

      // Initializers
      setBookingStatusOptions();
      changeBookingStatusTo('');

      function setBookingStatusOptions() {
        let bookingItemsDraft = 0;
        let bookingItemsPending = 0;
        let bookingItemsRequested = 0;
        let bookingItemsConfirmed = 0;
        let bookingItemsDeclined = 0;
        let bookingItemsCancelled = 0;

        let totalBookingItems = vm.booking.booking_items.length;

        vm.booking.booking_items.forEach(function (booking_item) {
          switch (booking_item.status) {
            case 'draft':
              bookingItemsDraft = bookingItemsDraft + 1;
              break;
            case 'pending':
              bookingItemsPending = bookingItemsPending + 1;
              break;
            case 'requested':
              bookingItemsRequested = bookingItemsRequested + 1;
              break;
            case 'confirmed':
              bookingItemsConfirmed = bookingItemsConfirmed + 1;
              break;
            case 'declined':
              bookingItemsDeclined = bookingItemsDeclined + 1;
              break;
            case 'cancelled':
              bookingItemsCancelled = bookingItemsCancelled + 1;
              break;
          }
        });

        switch (vm.booking.status) {
          case 'draft':
            vm.canProcess = true;
            vm.canCancel = true;
            break;
          case 'processing':
            if (totalBookingItems === bookingItemsConfirmed) {
              vm.canConfirm = true;
            }

            vm.canCancel = true;
            break;
          case 'confirmed':
            vm.canProcess = true;
            vm.canCancel = true;
            break;
          case 'cancelled':
            vm.canProcess = true;
            break;
        }

        if (bookingItemsPending >= 1 || bookingItemsRequested >= 1) {
          vm.showAlert = true;
        }
      }

      vm.changeBookingStatusTo = function (option) {
        changeBookingStatusTo(option); // important
      };

      function changeBookingStatusTo(option) {
        let modalMode = '';

        switch (option) {
          case 'process':
            modalMode = 'primary';
            break;
          case 'confirm':
            modalMode = 'success';
            break;
          case 'cancel':
            modalMode = 'danger';
            break;
          default:
            modalMode = 'default';
            break;
        }

        vm.option = option;
        vm.modalMode = modalMode;
      }

      vm.onBookingProcessed = function (bookingObj) {
        $element.modal('hide');
        successCallback(bookingObj);
      };

      vm.onBookingConfirmed = function (bookingObj) {
        $element.modal('hide');
        successCallback(bookingObj);
      };

      vm.onBookingCancelled = function (bookingObj) {
        $element.modal('hide');
        successCallback(bookingObj);
      };
    }

    // --------------------------- openSendBookingConfirmationToClient -------------------------

    // , successCallback
    function openSendBookingConfirmationToClient(booking) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/send-booking-confirmation-to-client-modal.html',
        controller: SendBookingConfirmationToClientCtrl,
        controllerAs: 'vm',
        inputs: {
          booking: booking,
          // successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      SendBookingConfirmationToClientCtrl.$inject = [
        '$element',
        'booking',
        // 'successCallback',
        'BookingService',
      ];
    }

    function SendBookingConfirmationToClientCtrl($element, booking, BookingService) {
      // successCallback,
      var vm = this;

      vm.clientEmail = angular.copy(booking.client.email);

      // Methods
      vm.sendBookingConfirmation = sendBookingConfirmation;

      function sendBookingConfirmation(isFormValid) {
        if (!isFormValid) {
          return;
        }

        vm.sendingForm = true;
        BookingService.sendBookingConfirmationToClient(
          booking.id,
          booking.company_id,
          vm.clientEmail
        ).then(function (data) {
          vm.sendingForm = false;

          $element.modal('hide');
          // successCallback(data);
        });
      }
    }

    // --------------------------- openSendBookingItineraryToClient -------------------------

    // , successCallback
    function openSendBookingItineraryToClient(booking) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/send-booking-itinerary-to-client-modal.html',
        controller: SendBookingItineraryToClientCtrl,
        controllerAs: 'vm',
        inputs: {
          booking: booking,
          // successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      SendBookingItineraryToClientCtrl.$inject = [
        '$element',
        'booking',
        // 'successCallback',
        'BookingService',
      ];
    }

    // , successCallback
    function SendBookingItineraryToClientCtrl($element, booking, BookingService) {
      var vm = this;

      vm.clientEmail = angular.copy(booking.client.email);

      // Methods
      vm.sendBookingItinerary = sendBookingItinerary;

      function sendBookingItinerary(isFormValid) {
        if (!isFormValid) {
          return;
        }

        vm.sendingForm = true;
        BookingService.sendBookingItineraryToClient(
          booking.id,
          booking.company_id,
          vm.clientEmail
        ).then(function (data) {
          vm.sendingForm = false;

          $element.modal('hide');
          // successCallback(data);
        });
      }
    }

    // --------------------------- openSendBookingVouchersToClient -------------------------

    // , successCallback
    function openSendBookingVouchersToClient(booking) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/send-booking-vouchers-to-client-modal.html',
        controller: SendBookingVouchersToClientCtrl,
        controllerAs: 'vm',
        inputs: {
          booking: booking,
          // successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      SendBookingVouchersToClientCtrl.$inject = [
        '$element',
        'booking',
        // 'successCallback',
        'BookingService',
      ];
    }

    // , successCallback
    function SendBookingVouchersToClientCtrl($element, booking, BookingService) {
      var vm = this;

      vm.clientEmail = angular.copy(booking.client.email);

      // Methods
      vm.sendBookingVouchers = sendBookingVouchers;

      function sendBookingVouchers(isFormValid) {
        if (!isFormValid) {
          return;
        }

        vm.sendingForm = true;
        BookingService.sendBookingVouchersToClient(
          booking.id,
          booking.company_id,
          vm.clientEmail
        ).then(function (data) {
          vm.sendingForm = false;

          $element.modal('hide');
          // successCallback(data);
        });
      }
    }

    // --------------------------- openSearchRelatedBookings -------------------------

    function openSearchRelatedBookings(bill, billProduct, provider, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/modals/search-related-bookings-modal.html',
        controller: SearchRelatedBookingModalCtrl,
        controllerAs: 'vm',
        inputs: {
          bill: bill,
          billProduct: billProduct,
          provider: provider,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      SearchRelatedBookingModalCtrl.$inject = [
        '$element',
        'bill',
        'billProduct',
        'provider',
        'successCallback',
      ];
    }

    function SearchRelatedBookingModalCtrl($element, bill, billProduct, provider, successCallback) {
      var vm = this;

      vm.bill = bill;
      vm.billProduct = billProduct;
      vm.provider = provider;

      // Methods
      vm.onBookingSelected = onBookingSelected;

      function onBookingSelected(booking) {
        $element.modal('hide');
        successCallback(booking);
      }
    }
  }
})();
